import axios from 'axios';
import authService from './auth.service.js';

// Create axios instance with default config
const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL || 'http://localhost:3001/api',
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
    withCredentials: true
});

api.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      await authService.refreshToken();
      originalRequest.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
      return api(originalRequest);
    }
    return Promise.reject(error);
  }
);

// Request interceptor
api.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token');
        if (token && token.trim()) {
            // Ensure proper Bearer token format
            config.headers.Authorization = `Bearer ${token.trim()}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// Response interceptor
api.interceptors.response.use(
    response => response,
    error => {
        if (error.response) {
            // Handle specific error status codes
            switch (error.response.status) {
                case 401:
                    // Handle unauthorized
                    break;
                case 404:
                    // Handle not found
                    break;
                case 500:
                    // Handle server error
                    break;
                default:
                    // Handle other errors
                    break;
            }
        }
        return Promise.reject(error);
    }
);

export default api;